import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Checkbox} from 'antd';

const InvoiceNoReceiptCheckbox = ({
  onEdit,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [checkboxProps, setCheckboxProps] = useState({disabled: false});

  const handleEdit = (e) => {
    if (onEdit) {
      setCheckboxProps({...checkboxProps, disabled: true});
      onEdit(e, () => {
        setCheckboxProps({...checkboxProps, disabled: false});
      });
    }
  }

  return (
    <Checkbox onChange={handleEdit} {...checkboxProps} {...rest}>
      {t(`invoiceTypes.noReceipt`)}
    </Checkbox>
  );
}

InvoiceNoReceiptCheckbox.propTypes = {
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
}

export default InvoiceNoReceiptCheckbox;
